module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/342a1155752090d7d2ec17511a47641d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/arrow_up.svg
// module id = kTqw
// module chunks = 0